/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { ApiConfigurationRequestInfo } from '../model/apiConfigurationRequestInfo';
import { ApiConfigurationResponseInfo } from '../model/apiConfigurationResponseInfo';
import { CampaignCreateRequest } from '../model/campaignCreateRequest';
import { CampaignOverrideCreateRequestInfo } from '../model/campaignOverrideCreateRequestInfo';
import { CampaignOverrideResInfo } from '../model/campaignOverrideResInfo';
import { CampaignOverrideResInfo2 } from '../model/campaignOverrideResInfo2';
import { CampaignOverrideResponseArrayInfoList } from '../model/campaignOverrideResponseArrayInfoList';
import { CampaignOverrideResponseInfo } from '../model/campaignOverrideResponseInfo';
import { CampaignOverrideupdaterequestInfoList } from '../model/campaignOverrideupdaterequestInfoList';
import { CampaignOverrideupdaterequestInfoList2 } from '../model/campaignOverrideupdaterequestInfoList2';
import { CampaignResponse } from '../model/campaignResponse';
import { CampaignResponseList } from '../model/campaignResponseList';
import { Campaignupdaterequest } from '../model/campaignupdaterequest';
import { Campaignupdateresponse } from '../model/campaignupdateresponse';
import { ClientCreateRequestInfo } from '../model/clientCreateRequestInfo';
import { ClientHierarchyResponseInfo } from '../model/clientHierarchyResponseInfo';
import { ClientParentResponseInfoList } from '../model/clientParentResponseInfoList';
import { ClientResponseInfo } from '../model/clientResponseInfo';
import { ClientSystemXrefRequestInfo } from '../model/clientSystemXrefRequestInfo';
import { ClientSystemXrefResponseInfo } from '../model/clientSystemXrefResponseInfo';
import { ClientUpdateRequestInfo } from '../model/clientUpdateRequestInfo';
import { ClientUpdateResponseInfo } from '../model/clientUpdateResponseInfo';
import { ClientidUpdateRequestInfo } from '../model/clientidUpdateRequestInfo';
import { ClientidUpdateResponseInfo } from '../model/clientidUpdateResponseInfo';
import { DashboardConfigurationCreateRequestInfo } from '../model/dashboardConfigurationCreateRequestInfo';
import { DashboardConfigurationResponseArrayInfoList } from '../model/dashboardConfigurationResponseArrayInfoList';
import { DashboardConfigurationResponseInfo } from '../model/dashboardConfigurationResponseInfo';
import { DatamartClientConfigCreateRequestInfo } from '../model/datamartClientConfigCreateRequestInfo';
import { DatamartClientConfigResInfo } from '../model/datamartClientConfigResInfo';
import { DatamartClientConfigResponseArrayInfoList } from '../model/datamartClientConfigResponseArrayInfoList';
import { DatamartClientConfigResponseInfo } from '../model/datamartClientConfigResponseInfo';
import { DatamartClientConfigupdaterequestInfoList } from '../model/datamartClientConfigupdaterequestInfoList';
import { DatamartTableConfigsInfoList } from '../model/datamartTableConfigsInfoList';
import { ErrorMessage } from '../model/errorMessage';
import { InlineResponse20012 } from '../model/inlineResponse20012';
import { IwsTableandViewListResponseType } from '../model/iwsTableandViewListResponseType';
import { JobControlClientCreateRequestInfo } from '../model/jobControlClientCreateRequestInfo';
import { JobControlClientHistoryResponseArrayInfoList } from '../model/jobControlClientHistoryResponseArrayInfoList';
import { JobControlClientResInfo } from '../model/jobControlClientResInfo';
import { JobControlClientResponseArrayInfoList } from '../model/jobControlClientResponseArrayInfoList';
import { JobControlClientResponseInfo } from '../model/jobControlClientResponseInfo';
import { JobControlClientupdaterequestInfoList } from '../model/jobControlClientupdaterequestInfoList';
import { JobResponseInfoList } from '../model/jobResponseInfoList';
import { ParoClientCreateRequest } from '../model/paroClientCreateRequest';
import { ParoClientResponse } from '../model/paroClientResponse';
import { ParoClientResponse2 } from '../model/paroClientResponse2';
import { ParoClientResponseList } from '../model/paroClientResponseList';
import { ParoClientupdaterequest } from '../model/paroClientupdaterequest';
import { Request7 } from '../model/request7';
import { SystemResponseInfoList } from '../model/systemResponseInfoList';
import { TableResponseInfoList } from '../model/tableResponseInfoList';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class IwsMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * IwsMgr_RetrieveAllApiConfiguration, Get all Api Configuration based on clientid
     * Get all Api Configuration based on clientid
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ApiConfigurationGet(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<ApiConfigurationResponseInfo>;
    public iwsMgrV1ApiConfigurationGet(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiConfigurationResponseInfo>>;
    public iwsMgrV1ApiConfigurationGet(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiConfigurationResponseInfo>>;
    public iwsMgrV1ApiConfigurationGet(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ApiConfigurationGet.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ApiConfigurationResponseInfo>(`${this.basePath}/IwsMgr/V1/ApiConfiguration`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_ApiConfigurationSave, Create,delete or update  a ApiConfiguration
     * Create,delete or update  a ApiConfiguration
     * @param ClientId Enter the ClientId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ApiConfigurationPut(ClientId: number, Request: ApiConfigurationRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ApiConfigurationResponseInfo>;
    public iwsMgrV1ApiConfigurationPut(ClientId: number, Request: ApiConfigurationRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApiConfigurationResponseInfo>>;
    public iwsMgrV1ApiConfigurationPut(ClientId: number, Request: ApiConfigurationRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApiConfigurationResponseInfo>>;
    public iwsMgrV1ApiConfigurationPut(ClientId: number, Request: ApiConfigurationRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ApiConfigurationPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1ApiConfigurationPut.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ApiConfigurationResponseInfo>(`${this.basePath}/IwsMgr/V1/ApiConfiguration`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_DeleteCampaign, Delete the request Client based on Campaign Id and ClientId
     * Delete the request Client based on Campaign Id and ClientId
     * @param ClientId Enter the ClientId
     * @param CampaignId Enter the CampaignId for which client needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1CampaignCampaignIdDelete(ClientId: number, CampaignId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public iwsMgrV1CampaignCampaignIdDelete(ClientId: number, CampaignId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public iwsMgrV1CampaignCampaignIdDelete(ClientId: number, CampaignId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public iwsMgrV1CampaignCampaignIdDelete(ClientId: number, CampaignId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1CampaignCampaignIdDelete.');
        }
        if (CampaignId === null || CampaignId === undefined) {
            throw new Error('Required parameter CampaignId was null or undefined when calling iwsMgrV1CampaignCampaignIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/IwsMgr/V1/Campaign/${encodeURIComponent(String(CampaignId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_UpdateCampaign, Update a  campaign based on Campaign Id and ClientId
     * Update a campaign based on Campaign Id and clientId
     * @param ClientId Enter the ClientId
     * @param CampaignId Enter the CampaignId for which client needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1CampaignCampaignIdPut(ClientId: number, CampaignId: number, Request: Campaignupdaterequest, observe?: 'body', reportProgress?: boolean): Observable<Campaignupdateresponse>;
    public iwsMgrV1CampaignCampaignIdPut(ClientId: number, CampaignId: number, Request: Campaignupdaterequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Campaignupdateresponse>>;
    public iwsMgrV1CampaignCampaignIdPut(ClientId: number, CampaignId: number, Request: Campaignupdaterequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Campaignupdateresponse>>;
    public iwsMgrV1CampaignCampaignIdPut(ClientId: number, CampaignId: number, Request: Campaignupdaterequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1CampaignCampaignIdPut.');
        }
        if (CampaignId === null || CampaignId === undefined) {
            throw new Error('Required parameter CampaignId was null or undefined when calling iwsMgrV1CampaignCampaignIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1CampaignCampaignIdPut.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<Campaignupdateresponse>(`${this.basePath}/IwsMgr/V1/Campaign/${encodeURIComponent(String(CampaignId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveCampaign, Get all campaigns based on clientid
     * Get all campaigns based on clientid
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1CampaignGet(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<CampaignResponseList>;
    public iwsMgrV1CampaignGet(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CampaignResponseList>>;
    public iwsMgrV1CampaignGet(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CampaignResponseList>>;
    public iwsMgrV1CampaignGet(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1CampaignGet.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<CampaignResponseList>(`${this.basePath}/IwsMgr/V1/Campaign`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveCampaignOverride, Get all campaign Override based on clientid or campaignid or both
     * Get all campaign Override based on clientid or campaignid or both
     * @param ClientId Enter the ClientId
     * @param CampaignId Enter the Campaign
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1CampaignOverrideGet(ClientId: number, CampaignId?: number, observe?: 'body', reportProgress?: boolean): Observable<CampaignOverrideResponseArrayInfoList>;
    public iwsMgrV1CampaignOverrideGet(ClientId: number, CampaignId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CampaignOverrideResponseArrayInfoList>>;
    public iwsMgrV1CampaignOverrideGet(ClientId: number, CampaignId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CampaignOverrideResponseArrayInfoList>>;
    public iwsMgrV1CampaignOverrideGet(ClientId: number, CampaignId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1CampaignOverrideGet.');
        }

        let headers = this.defaultHeaders;
        if (CampaignId !== undefined && CampaignId !== null) {
            headers = headers.set('CampaignId', String(CampaignId));
        }
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<CampaignOverrideResponseArrayInfoList>(`${this.basePath}/IwsMgr/V1/CampaignOverride`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_DeleteCampaignOverride, Delete the request Client based on Id
     * Delete the request Client based on Id
     * @param ClientId Enter the ClientId
     * @param Id Enter the Id for which campaignOverride needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1CampaignOverrideIdDelete(ClientId: number, Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public iwsMgrV1CampaignOverrideIdDelete(ClientId: number, Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public iwsMgrV1CampaignOverrideIdDelete(ClientId: number, Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public iwsMgrV1CampaignOverrideIdDelete(ClientId: number, Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1CampaignOverrideIdDelete.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling iwsMgrV1CampaignOverrideIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/IwsMgr/V1/CampaignOverride/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_UpdateCampaignOverride, Update a  campaignOverride based on Id
     * Update a  campaignOverride based on Id
     * @param Id Enter the Id for which campaign Override needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1CampaignOverrideIdPut(Id: number, Request: CampaignOverrideupdaterequestInfoList, observe?: 'body', reportProgress?: boolean): Observable<CampaignOverrideResInfo>;
    public iwsMgrV1CampaignOverrideIdPut(Id: number, Request: CampaignOverrideupdaterequestInfoList, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CampaignOverrideResInfo>>;
    public iwsMgrV1CampaignOverrideIdPut(Id: number, Request: CampaignOverrideupdaterequestInfoList, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CampaignOverrideResInfo>>;
    public iwsMgrV1CampaignOverrideIdPut(Id: number, Request: CampaignOverrideupdaterequestInfoList, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling iwsMgrV1CampaignOverrideIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1CampaignOverrideIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<CampaignOverrideResInfo>(`${this.basePath}/IwsMgr/V1/CampaignOverride/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_CreateCampaignOverride, Create CampaignOverride
     * Create a CampaignOverride
     * @param ClientId Enter the ClientId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1CampaignOverridePost(ClientId: number, Request: CampaignOverrideCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<CampaignOverrideResponseInfo>;
    public iwsMgrV1CampaignOverridePost(ClientId: number, Request: CampaignOverrideCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CampaignOverrideResponseInfo>>;
    public iwsMgrV1CampaignOverridePost(ClientId: number, Request: CampaignOverrideCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CampaignOverrideResponseInfo>>;
    public iwsMgrV1CampaignOverridePost(ClientId: number, Request: CampaignOverrideCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1CampaignOverridePost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1CampaignOverridePost.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<CampaignOverrideResponseInfo>(`${this.basePath}/IwsMgr/V1/CampaignOverride`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_CreateCampaign, Create Campaign for each client
     * Create a Campaign for each client
     * @param ClientId Enter the ClientId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1CampaignPost(ClientId: number, Request: CampaignCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<CampaignResponse>;
    public iwsMgrV1CampaignPost(ClientId: number, Request: CampaignCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CampaignResponse>>;
    public iwsMgrV1CampaignPost(ClientId: number, Request: CampaignCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CampaignResponse>>;
    public iwsMgrV1CampaignPost(ClientId: number, Request: CampaignCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1CampaignPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1CampaignPost.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<CampaignResponse>(`${this.basePath}/IwsMgr/V1/Campaign`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveClientConfig, Get client config record based on clientid
     * Get client config record
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientClientIdConfigGet(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<ClientidUpdateResponseInfo>;
    public iwsMgrV1ClientClientIdConfigGet(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientidUpdateResponseInfo>>;
    public iwsMgrV1ClientClientIdConfigGet(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientidUpdateResponseInfo>>;
    public iwsMgrV1ClientClientIdConfigGet(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ClientClientIdConfigGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ClientidUpdateResponseInfo>(`${this.basePath}/IwsMgr/V1/Client/${encodeURIComponent(String(ClientId))}/Config`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_UpdateClientConfig, Update a client config based on client id
     * Update a client config based on client id
     * @param ClientId Enter the ClientId for which client needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientClientIdConfigPatch(ClientId: number, Request: ClientidUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ClientidUpdateResponseInfo>;
    public iwsMgrV1ClientClientIdConfigPatch(ClientId: number, Request: ClientidUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientidUpdateResponseInfo>>;
    public iwsMgrV1ClientClientIdConfigPatch(ClientId: number, Request: ClientidUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientidUpdateResponseInfo>>;
    public iwsMgrV1ClientClientIdConfigPatch(ClientId: number, Request: ClientidUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ClientClientIdConfigPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1ClientClientIdConfigPatch.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<ClientidUpdateResponseInfo>(`${this.basePath}/IwsMgr/V1/Client/${encodeURIComponent(String(ClientId))}/Config`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_DeleteClient, Delete the requested Client
     * Delete the requested Client
     * @param ClientId Enter the Client id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientClientIdDelete(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public iwsMgrV1ClientClientIdDelete(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public iwsMgrV1ClientClientIdDelete(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public iwsMgrV1ClientClientIdDelete(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ClientClientIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/IwsMgr/V1/Client/${encodeURIComponent(String(ClientId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveClient, Get Client based on clientid
     * Get Client based on clientid
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientClientIdGet(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<ClientUpdateResponseInfo>;
    public iwsMgrV1ClientClientIdGet(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientUpdateResponseInfo>>;
    public iwsMgrV1ClientClientIdGet(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientUpdateResponseInfo>>;
    public iwsMgrV1ClientClientIdGet(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ClientClientIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ClientUpdateResponseInfo>(`${this.basePath}/IwsMgr/V1/Client/${encodeURIComponent(String(ClientId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_ClientHierarchy, Search the Client by Id
     * Retrieve the Client Hierarchy based on ClientId
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientClientIdHierarchyGet(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<ClientHierarchyResponseInfo>;
    public iwsMgrV1ClientClientIdHierarchyGet(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientHierarchyResponseInfo>>;
    public iwsMgrV1ClientClientIdHierarchyGet(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientHierarchyResponseInfo>>;
    public iwsMgrV1ClientClientIdHierarchyGet(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ClientClientIdHierarchyGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ClientHierarchyResponseInfo>(`${this.basePath}/IwsMgr/V1/Client/${encodeURIComponent(String(ClientId))}/Hierarchy`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_UpdateClient, Update Client
     * Update a Client
     * @param ClientId Enter the ClientId for which client needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientClientIdPut(ClientId: number, Request: ClientUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ClientUpdateResponseInfo>;
    public iwsMgrV1ClientClientIdPut(ClientId: number, Request: ClientUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientUpdateResponseInfo>>;
    public iwsMgrV1ClientClientIdPut(ClientId: number, Request: ClientUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientUpdateResponseInfo>>;
    public iwsMgrV1ClientClientIdPut(ClientId: number, Request: ClientUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ClientClientIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1ClientClientIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ClientUpdateResponseInfo>(`${this.basePath}/IwsMgr/V1/Client/${encodeURIComponent(String(ClientId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveAllParent, Get all Parent clients
     * Get all Parent clients
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientParentGet(observe?: 'body', reportProgress?: boolean): Observable<ClientParentResponseInfoList>;
    public iwsMgrV1ClientParentGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientParentResponseInfoList>>;
    public iwsMgrV1ClientParentGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientParentResponseInfoList>>;
    public iwsMgrV1ClientParentGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ClientParentResponseInfoList>(`${this.basePath}/IwsMgr/V1/Client/Parent`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_CreateClient, Create Client
     * Create a Client
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientPost(Request: ClientCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ClientResponseInfo>;
    public iwsMgrV1ClientPost(Request: ClientCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientResponseInfo>>;
    public iwsMgrV1ClientPost(Request: ClientCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientResponseInfo>>;
    public iwsMgrV1ClientPost(Request: ClientCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1ClientPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ClientResponseInfo>(`${this.basePath}/IwsMgr/V1/Client`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveAllClientSystemXref, Get all client system xref based on clientid and SystemId
     * Get all client system xref based on clientid and systemId
     * @param ClientId Enter the ClientId
     * @param SystemId Enter the SystemId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientSystemXrefGet(ClientId: number, SystemId?: number, observe?: 'body', reportProgress?: boolean): Observable<ClientSystemXrefResponseInfo>;
    public iwsMgrV1ClientSystemXrefGet(ClientId: number, SystemId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientSystemXrefResponseInfo>>;
    public iwsMgrV1ClientSystemXrefGet(ClientId: number, SystemId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientSystemXrefResponseInfo>>;
    public iwsMgrV1ClientSystemXrefGet(ClientId: number, SystemId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ClientSystemXrefGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (SystemId !== undefined) {
            queryParameters = queryParameters.set('SystemId', <any>SystemId);
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ClientSystemXrefResponseInfo>(`${this.basePath}/IwsMgr/V1/ClientSystemXref`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_ClientSystemXrefSave, Create a client system xref
     * Create a client system xref
     * @param ClientId Enter the ClientId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ClientSystemXrefPut(ClientId: number, Request: ClientSystemXrefRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<ClientSystemXrefResponseInfo>;
    public iwsMgrV1ClientSystemXrefPut(ClientId: number, Request: ClientSystemXrefRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientSystemXrefResponseInfo>>;
    public iwsMgrV1ClientSystemXrefPut(ClientId: number, Request: ClientSystemXrefRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientSystemXrefResponseInfo>>;
    public iwsMgrV1ClientSystemXrefPut(ClientId: number, Request: ClientSystemXrefRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ClientSystemXrefPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1ClientSystemXrefPut.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<ClientSystemXrefResponseInfo>(`${this.basePath}/IwsMgr/V1/ClientSystemXref`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveAllColumnNames, Get all Column Names
     * Get all Column Names
     * @param TableName Enter the Tablename to get the column names
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1DBTableViewColumnsListGet(TableName: string, observe?: 'body', reportProgress?: boolean): Observable<TableResponseInfoList>;
    public iwsMgrV1DBTableViewColumnsListGet(TableName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TableResponseInfoList>>;
    public iwsMgrV1DBTableViewColumnsListGet(TableName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TableResponseInfoList>>;
    public iwsMgrV1DBTableViewColumnsListGet(TableName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (TableName === null || TableName === undefined) {
            throw new Error('Required parameter TableName was null or undefined when calling iwsMgrV1DBTableViewColumnsListGet.');
        }

        let headers = this.defaultHeaders;
        if (TableName !== undefined && TableName !== null) {
            headers = headers.set('TableName', String(TableName));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<TableResponseInfoList>(`${this.basePath}/IwsMgr/V1/DBTableViewColumnsList`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveTableAndViewList, Retrieve list of Table and View name
     * Retrieve list of Table and View name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1DBTableViewListGet(observe?: 'body', reportProgress?: boolean): Observable<IwsTableandViewListResponseType>;
    public iwsMgrV1DBTableViewListGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<IwsTableandViewListResponseType>>;
    public iwsMgrV1DBTableViewListGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<IwsTableandViewListResponseType>>;
    public iwsMgrV1DBTableViewListGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<IwsTableandViewListResponseType>(`${this.basePath}/IwsMgr/V1/DBTableViewList`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveDatamartClientConfig, Get all datamart configurations based on clientid
     * Get all datamart configurations based on clientid
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1DataMartClientConfigurationGet(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<DatamartClientConfigResponseArrayInfoList>;
    public iwsMgrV1DataMartClientConfigurationGet(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatamartClientConfigResponseArrayInfoList>>;
    public iwsMgrV1DataMartClientConfigurationGet(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatamartClientConfigResponseArrayInfoList>>;
    public iwsMgrV1DataMartClientConfigurationGet(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1DataMartClientConfigurationGet.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DatamartClientConfigResponseArrayInfoList>(`${this.basePath}/IwsMgr/V1/DataMart/ClientConfiguration`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_DeleteDatamartClientConfig, Delete the datamart Client config based on Id
     * Delete the Client based on Id
     * @param ClientId Enter the ClientId
     * @param Id Enter the Id for which client needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1DataMartClientConfigurationIdDelete(ClientId: number, Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public iwsMgrV1DataMartClientConfigurationIdDelete(ClientId: number, Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public iwsMgrV1DataMartClientConfigurationIdDelete(ClientId: number, Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public iwsMgrV1DataMartClientConfigurationIdDelete(ClientId: number, Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1DataMartClientConfigurationIdDelete.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling iwsMgrV1DataMartClientConfigurationIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/IwsMgr/V1/DataMart/ClientConfiguration/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_UpdateDatamartClientConfig, Update datamart client config based on Id
     * Update datamart client config based on Id
     * @param ClientId Enter the ClientId
     * @param Id Enter the id for which client needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1DataMartClientConfigurationIdPatch(ClientId: number, Id: number, Request: DatamartClientConfigupdaterequestInfoList, observe?: 'body', reportProgress?: boolean): Observable<DatamartClientConfigResInfo>;
    public iwsMgrV1DataMartClientConfigurationIdPatch(ClientId: number, Id: number, Request: DatamartClientConfigupdaterequestInfoList, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatamartClientConfigResInfo>>;
    public iwsMgrV1DataMartClientConfigurationIdPatch(ClientId: number, Id: number, Request: DatamartClientConfigupdaterequestInfoList, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatamartClientConfigResInfo>>;
    public iwsMgrV1DataMartClientConfigurationIdPatch(ClientId: number, Id: number, Request: DatamartClientConfigupdaterequestInfoList, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1DataMartClientConfigurationIdPatch.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling iwsMgrV1DataMartClientConfigurationIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1DataMartClientConfigurationIdPatch.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<DatamartClientConfigResInfo>(`${this.basePath}/IwsMgr/V1/DataMart/ClientConfiguration/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_CreateDatamartClientConfig, Create datamart client Config
     * Create datamart client Config
     * @param ClientId Enter the ClientId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1DataMartClientConfigurationPost(ClientId: number, Request: DatamartClientConfigCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<DatamartClientConfigResponseInfo>;
    public iwsMgrV1DataMartClientConfigurationPost(ClientId: number, Request: DatamartClientConfigCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatamartClientConfigResponseInfo>>;
    public iwsMgrV1DataMartClientConfigurationPost(ClientId: number, Request: DatamartClientConfigCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatamartClientConfigResponseInfo>>;
    public iwsMgrV1DataMartClientConfigurationPost(ClientId: number, Request: DatamartClientConfigCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1DataMartClientConfigurationPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1DataMartClientConfigurationPost.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DatamartClientConfigResponseInfo>(`${this.basePath}/IwsMgr/V1/DataMart/ClientConfiguration`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveAllDatamartConfig, Get all datamart Configs
     * Get all Configs
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1DataMartTableConfigurationGet(observe?: 'body', reportProgress?: boolean): Observable<DatamartTableConfigsInfoList>;
    public iwsMgrV1DataMartTableConfigurationGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DatamartTableConfigsInfoList>>;
    public iwsMgrV1DataMartTableConfigurationGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DatamartTableConfigsInfoList>>;
    public iwsMgrV1DataMartTableConfigurationGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DatamartTableConfigsInfoList>(`${this.basePath}/IwsMgr/V1/DataMart/TableConfiguration`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_FileDownload, Download the iws files from the vault
     * Download the iws files from the vault based on ClientId and Filename.
     * @param FileName Enter the FileName
     * @param FilePath Enter the FilePath
     * @param Depth Enter the Depth - number of sub directories to look for
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1FileDownloadGet(FileName: string, FilePath: string, Depth?: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public iwsMgrV1FileDownloadGet(FileName: string, FilePath: string, Depth?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public iwsMgrV1FileDownloadGet(FileName: string, FilePath: string, Depth?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public iwsMgrV1FileDownloadGet(FileName: string, FilePath: string, Depth?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (FileName === null || FileName === undefined) {
            throw new Error('Required parameter FileName was null or undefined when calling iwsMgrV1FileDownloadGet.');
        }
        if (FilePath === null || FilePath === undefined) {
            throw new Error('Required parameter FilePath was null or undefined when calling iwsMgrV1FileDownloadGet.');
        }

        let headers = this.defaultHeaders;
        if (FileName !== undefined && FileName !== null) {
            headers = headers.set('FileName', String(FileName));
        }
        if (FilePath !== undefined && FilePath !== null) {
            headers = headers.set('FilePath', String(FilePath));
        }
        if (Depth !== undefined && Depth !== null) {
            headers = headers.set('Depth', String(Depth));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/csv',
            'application/txt',
            'application/pdf',
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
        ];

        return this.httpClient.get(`${this.basePath}/IwsMgr/V1/File/Download`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_GenericSearch, Search iws Guarantor records
     * Search iws Guarantor records based on given parameters
     * @param ClientId Enter the ClientId
     * @param request Enter the Guarantor specific information in the JSON format.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1GenericSearchPost(ClientId: number, request: Request7, observe?: 'body', reportProgress?: boolean): Observable<Array<InlineResponse20012>>;
    public iwsMgrV1GenericSearchPost(ClientId: number, request: Request7, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<InlineResponse20012>>>;
    public iwsMgrV1GenericSearchPost(ClientId: number, request: Request7, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<InlineResponse20012>>>;
    public iwsMgrV1GenericSearchPost(ClientId: number, request: Request7, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1GenericSearchPost.');
        }
        if (request === null || request === undefined) {
            throw new Error('Required parameter request was null or undefined when calling iwsMgrV1GenericSearchPost.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<Array<InlineResponse20012>>(`${this.basePath}/IwsMgr/V1/Generic/Search`,
            request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveAllDashboardConfiguration, Get all dashboardConfigurations for IWS
     * Get all dashboardConfigurations for IWS
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1IwsDashboardConfigurationGet(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<DashboardConfigurationResponseArrayInfoList>;
    public iwsMgrV1IwsDashboardConfigurationGet(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DashboardConfigurationResponseArrayInfoList>>;
    public iwsMgrV1IwsDashboardConfigurationGet(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DashboardConfigurationResponseArrayInfoList>>;
    public iwsMgrV1IwsDashboardConfigurationGet(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1IwsDashboardConfigurationGet.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<DashboardConfigurationResponseArrayInfoList>(`${this.basePath}/IwsMgr/V1/IwsDashboardConfiguration`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_DeleteDashboardConfiguration, Delete the request dashboardconfiguration based on Id
     * Delete the request dashboardconfiguration based on Id
     * @param ClientId Enter the ClientId
     * @param Id Enter the Id for which dashboardconfiguration needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1IwsDashboardConfigurationIdDelete(ClientId: number, Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public iwsMgrV1IwsDashboardConfigurationIdDelete(ClientId: number, Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public iwsMgrV1IwsDashboardConfigurationIdDelete(ClientId: number, Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public iwsMgrV1IwsDashboardConfigurationIdDelete(ClientId: number, Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1IwsDashboardConfigurationIdDelete.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling iwsMgrV1IwsDashboardConfigurationIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/IwsMgr/V1/IwsDashboardConfiguration/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_UpdateDashboardConfiguration, Update a  dashboardConfiguration based on Id
     * Update a  dashboardConfiguration based on Id
     * @param ClientId Enter the ClientId
     * @param Id Enter the Id for which dashboard Configuration needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1IwsDashboardConfigurationIdPut(ClientId: number, Id: number, Request: CampaignOverrideupdaterequestInfoList2, observe?: 'body', reportProgress?: boolean): Observable<CampaignOverrideResInfo2>;
    public iwsMgrV1IwsDashboardConfigurationIdPut(ClientId: number, Id: number, Request: CampaignOverrideupdaterequestInfoList2, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CampaignOverrideResInfo2>>;
    public iwsMgrV1IwsDashboardConfigurationIdPut(ClientId: number, Id: number, Request: CampaignOverrideupdaterequestInfoList2, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CampaignOverrideResInfo2>>;
    public iwsMgrV1IwsDashboardConfigurationIdPut(ClientId: number, Id: number, Request: CampaignOverrideupdaterequestInfoList2, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1IwsDashboardConfigurationIdPut.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling iwsMgrV1IwsDashboardConfigurationIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1IwsDashboardConfigurationIdPut.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<CampaignOverrideResInfo2>(`${this.basePath}/IwsMgr/V1/IwsDashboardConfiguration/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_CreatedashboardConfiguration, Create dashboardConfiguration
     * Create dashboardConfiguration
     * @param ClientId Enter the ClientId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1IwsDashboardConfigurationPost(ClientId: number, Request: DashboardConfigurationCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<DashboardConfigurationResponseInfo>;
    public iwsMgrV1IwsDashboardConfigurationPost(ClientId: number, Request: DashboardConfigurationCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<DashboardConfigurationResponseInfo>>;
    public iwsMgrV1IwsDashboardConfigurationPost(ClientId: number, Request: DashboardConfigurationCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<DashboardConfigurationResponseInfo>>;
    public iwsMgrV1IwsDashboardConfigurationPost(ClientId: number, Request: DashboardConfigurationCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1IwsDashboardConfigurationPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1IwsDashboardConfigurationPost.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<DashboardConfigurationResponseInfo>(`${this.basePath}/IwsMgr/V1/IwsDashboardConfiguration`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveAllJobControlClient, Get all job control client based on clientid
     * Get all job control client based on clientid
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1JobControlClientGet(ClientId: number, observe?: 'body', reportProgress?: boolean): Observable<JobControlClientResponseArrayInfoList>;
    public iwsMgrV1JobControlClientGet(ClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobControlClientResponseArrayInfoList>>;
    public iwsMgrV1JobControlClientGet(ClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobControlClientResponseArrayInfoList>>;
    public iwsMgrV1JobControlClientGet(ClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1JobControlClientGet.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<JobControlClientResponseArrayInfoList>(`${this.basePath}/IwsMgr/V1/JobControlClient`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_JobControlClientHistoryRetrieve, Get all job records based on JobControlClientId
     * Get all job records based on JobControlClientId
     * @param JobControlClientId Enter the JobControlClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1JobControlClientHistoryJobControlClientIdGet(JobControlClientId: number, observe?: 'body', reportProgress?: boolean): Observable<JobControlClientHistoryResponseArrayInfoList>;
    public iwsMgrV1JobControlClientHistoryJobControlClientIdGet(JobControlClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobControlClientHistoryResponseArrayInfoList>>;
    public iwsMgrV1JobControlClientHistoryJobControlClientIdGet(JobControlClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobControlClientHistoryResponseArrayInfoList>>;
    public iwsMgrV1JobControlClientHistoryJobControlClientIdGet(JobControlClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (JobControlClientId === null || JobControlClientId === undefined) {
            throw new Error('Required parameter JobControlClientId was null or undefined when calling iwsMgrV1JobControlClientHistoryJobControlClientIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<JobControlClientHistoryResponseArrayInfoList>(`${this.basePath}/IwsMgr/V1/JobControlClientHistory/${encodeURIComponent(String(JobControlClientId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_DeleteJobControlClient, Delete the request Client based on Job Control Client Id
     * Delete the request Client based on Job Control Client Id
     * @param ClientId Enter the ClientId
     * @param JobControlClientId Enter the JobControlClientId for which client needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1JobControlClientJobControlClientIdDelete(ClientId: number, JobControlClientId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public iwsMgrV1JobControlClientJobControlClientIdDelete(ClientId: number, JobControlClientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public iwsMgrV1JobControlClientJobControlClientIdDelete(ClientId: number, JobControlClientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public iwsMgrV1JobControlClientJobControlClientIdDelete(ClientId: number, JobControlClientId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1JobControlClientJobControlClientIdDelete.');
        }
        if (JobControlClientId === null || JobControlClientId === undefined) {
            throw new Error('Required parameter JobControlClientId was null or undefined when calling iwsMgrV1JobControlClientJobControlClientIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/IwsMgr/V1/JobControlClient/${encodeURIComponent(String(JobControlClientId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_UpdateJobControlClient, Update a  job control client based on Job Control Client Id
     * Update a  job control client based on Job Control Client Id
     * @param ClientId Enter the ClientId
     * @param JobControlClientId Enter the JobControlClientId for which client needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1JobControlClientJobControlClientIdPatch(ClientId: number, JobControlClientId: number, Request: JobControlClientupdaterequestInfoList, observe?: 'body', reportProgress?: boolean): Observable<JobControlClientResInfo>;
    public iwsMgrV1JobControlClientJobControlClientIdPatch(ClientId: number, JobControlClientId: number, Request: JobControlClientupdaterequestInfoList, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobControlClientResInfo>>;
    public iwsMgrV1JobControlClientJobControlClientIdPatch(ClientId: number, JobControlClientId: number, Request: JobControlClientupdaterequestInfoList, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobControlClientResInfo>>;
    public iwsMgrV1JobControlClientJobControlClientIdPatch(ClientId: number, JobControlClientId: number, Request: JobControlClientupdaterequestInfoList, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1JobControlClientJobControlClientIdPatch.');
        }
        if (JobControlClientId === null || JobControlClientId === undefined) {
            throw new Error('Required parameter JobControlClientId was null or undefined when calling iwsMgrV1JobControlClientJobControlClientIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1JobControlClientJobControlClientIdPatch.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<JobControlClientResInfo>(`${this.basePath}/IwsMgr/V1/JobControlClient/${encodeURIComponent(String(JobControlClientId))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_CreateJobControlClient, Create JobControlClient
     * Create a JobControlClient
     * @param ClientId Enter the ClientId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1JobControlClientPost(ClientId: number, Request: JobControlClientCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<JobControlClientResponseInfo>;
    public iwsMgrV1JobControlClientPost(ClientId: number, Request: JobControlClientCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobControlClientResponseInfo>>;
    public iwsMgrV1JobControlClientPost(ClientId: number, Request: JobControlClientCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobControlClientResponseInfo>>;
    public iwsMgrV1JobControlClientPost(ClientId: number, Request: JobControlClientCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1JobControlClientPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1JobControlClientPost.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<JobControlClientResponseInfo>(`${this.basePath}/IwsMgr/V1/JobControlClient`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveAllJobs, Get all jobs
     * Get all Jobs
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1JobGet(observe?: 'body', reportProgress?: boolean): Observable<JobResponseInfoList>;
    public iwsMgrV1JobGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<JobResponseInfoList>>;
    public iwsMgrV1JobGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<JobResponseInfoList>>;
    public iwsMgrV1JobGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<JobResponseInfoList>(`${this.basePath}/IwsMgr/V1/Job`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveParoClient, Get ParoClient based on clientid
     * Get ParoClient based on clientid
     * @param ClientId Enter the ClientId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ParoClientGet(ClientId: string, observe?: 'body', reportProgress?: boolean): Observable<ParoClientResponseList>;
    public iwsMgrV1ParoClientGet(ClientId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ParoClientResponseList>>;
    public iwsMgrV1ParoClientGet(ClientId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ParoClientResponseList>>;
    public iwsMgrV1ParoClientGet(ClientId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ParoClientGet.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ParoClientResponseList>(`${this.basePath}/IwsMgr/V1/ParoClient`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_DeleteParoClient, Delete the request Client based on Id and ClientId
     * Delete the request Client based on Id and ClientId
     * @param ClientId Enter the ClientId
     * @param Id Enter the Id for which client needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ParoClientIdDelete(ClientId: string, Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public iwsMgrV1ParoClientIdDelete(ClientId: string, Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public iwsMgrV1ParoClientIdDelete(ClientId: string, Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public iwsMgrV1ParoClientIdDelete(ClientId: string, Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ParoClientIdDelete.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling iwsMgrV1ParoClientIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/IwsMgr/V1/ParoClient/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_UpdateParoClient, Update a  ParoClient based on Id and ClientId
     * Update a ParoClient based on Id and clientId
     * @param ClientId Enter the ClientId
     * @param Id Enter the Id for which client needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ParoClientIdPatch(ClientId: string, Id: number, Request: ParoClientupdaterequest, observe?: 'body', reportProgress?: boolean): Observable<ParoClientResponse2>;
    public iwsMgrV1ParoClientIdPatch(ClientId: string, Id: number, Request: ParoClientupdaterequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ParoClientResponse2>>;
    public iwsMgrV1ParoClientIdPatch(ClientId: string, Id: number, Request: ParoClientupdaterequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ParoClientResponse2>>;
    public iwsMgrV1ParoClientIdPatch(ClientId: string, Id: number, Request: ParoClientupdaterequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ParoClientIdPatch.');
        }
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling iwsMgrV1ParoClientIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1ParoClientIdPatch.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<ParoClientResponse2>(`${this.basePath}/IwsMgr/V1/ParoClient/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_CreateParoClient, Create ParoClient
     * Create ParoClient
     * @param ClientId Enter the ClientId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1ParoClientPost(ClientId: string, Request: ParoClientCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<ParoClientResponse>;
    public iwsMgrV1ParoClientPost(ClientId: string, Request: ParoClientCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ParoClientResponse>>;
    public iwsMgrV1ParoClientPost(ClientId: string, Request: ParoClientCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ParoClientResponse>>;
    public iwsMgrV1ParoClientPost(ClientId: string, Request: ParoClientCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (ClientId === null || ClientId === undefined) {
            throw new Error('Required parameter ClientId was null or undefined when calling iwsMgrV1ParoClientPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling iwsMgrV1ParoClientPost.');
        }

        let headers = this.defaultHeaders;
        if (ClientId !== undefined && ClientId !== null) {
            headers = headers.set('ClientId', String(ClientId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<ParoClientResponse>(`${this.basePath}/IwsMgr/V1/ParoClient`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * IwsMgr_RetrieveAllSystems, Get all Systems
     * Get all Systems
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public iwsMgrV1SystemGet(observe?: 'body', reportProgress?: boolean): Observable<SystemResponseInfoList>;
    public iwsMgrV1SystemGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SystemResponseInfoList>>;
    public iwsMgrV1SystemGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SystemResponseInfoList>>;
    public iwsMgrV1SystemGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SystemResponseInfoList>(`${this.basePath}/IwsMgr/V1/System`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
